import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class FormInputIconComponent extends React.Component {
    static propTypes = {
        icon: PropTypes.shape({
            style: PropTypes.oneOf(['default', 'small']),
            placement: PropTypes.oneOf(['left', 'right']).isRequired,
            type: PropTypes.oneOf(['fa', 'image']).isRequired,
            src: PropTypes.string.isRequired
        }).isRequired
    };
    static defaultProps = {}

    getIcon = icon => {
        switch (icon.type) {
            case 'fa':
                return (<i className={icon.src} />);
            case 'image':
                return (<img src={icon.src} />);
        }
    }

    render() {
        const { icon } = this.props;

        return (
            <div className={`component-form-input-icon ${icon.placement} ${icon.style}`}>
                {this.getIcon(icon)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms2/InputIcon/index.js